import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clickable-row"
export default class extends Controller {
  static values = { url: String }
  // connect() {
  // }

  visit(event){
    if (event.target.closest("a, button, input, select, textarea")) return

    const link = this.element.querySelector("a.row-link")

    if (link) {
      link.click()
    } else {
      console.log("Link not found")
    }
  }
}
